import type { AssetWithStats } from '@/common/asset';
import type { Pagination } from '@/common/pagination';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type AssetListSuccessResponseType = {
	assets: AssetWithStats[];
	total: number;
	limit: number;
	offset: number;
};

export type AssetListQueryFilterType = {
	search?: string;
	organizationId?: string;
	// Without organizationId, also list assets of inactive organizations
	includeInactive?: boolean;
	minConditionRating?: string;
	maxConditionRating?: string;
	/** Allowlisted `field:asc|desc` pairs, see ASSET_SORT_FIELDS in the backend DTO. */
	sort?: string;
	/** Only deleted assets (needs ASSETS_DELETE) */
	deleted?: boolean;
};

export type AssetsQueryParams = AssetListQueryFilterType & Pagination;

export async function getListAssets(query: AssetsQueryParams): Promise<AssetListSuccessResponseType | null> {
	const response = await axios.get(`${API_URLS.ASSETS.INDEX}`, {
		params: query,
	});
	return getResponse<AssetListSuccessResponseType>(response.data);
}
